import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Pages } from 'core/pages';

const Dashboard = lazy(() => import('./Dashboard'));
const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const ResourcePage = lazy(() => import('./ResourcePage'));
const Versions = lazy(() => import('./Versions'));
const Update = lazy(() => import('./Update'));
const UpdateStatus = lazy(() => import('./UpdateStatus'));

export function CompetitionRoutes() {
  return (
    <Routes>
      <Route path={Pages.sports.cricket.competition.meta.path}>
        <Route
          index
          element={(<Dashboard />)}
        />
        <Route
          path={Pages.sports.cricket.competition.list.meta.path}
          element={(<List />)}
        />
        <Route
          path={Pages.sports.cricket.competition.create.meta.path}
          element={(<Create />)}
        />
        <Route
          path={Pages.sports.cricket.competition.read.meta.path}
          element={(<ResourcePage />)}
        />
        <Route
          path={Pages.sports.cricket.competition.versions.meta.path}
          element={(<Versions />)}
        />
        <Route
          path={Pages.sports.cricket.competition.update.meta.path}
          element={(<Update />)}
        />
        <Route
          path={Pages.sports.cricket.competition.updateStatus.meta.path}
          element={(<UpdateStatus />)}
        />
      </Route>
    </Routes>
  );
}
